import VentureScreen from '@/modules/home/components/VentureScreen';
import { VentureScreenWeb } from '@/modules/home/components/VentureScreenWeb';
import { useVenture } from '@/modules/home/hooks/useVentures';
import { useLocalSearchParams } from 'expo-router';
import { Platform } from 'react-native';
import React, { useMemo } from 'react';
export default function VentureRoute() {
    const params = useLocalSearchParams();
    const ventureId = typeof params.id === 'string' ? params.id : undefined;

    const { data, isLoading } = useVenture(ventureId);

    const servicesHeading = useMemo(() => data?.featuredItemsHeading || null, [data]);
    const services = useMemo(() => data?.featuredItems || [], [data]);

    const commonProps = {
        ventureId: ventureId as string | undefined,
        ventureName: (data?.name ?? null) as string | null | undefined,
        ventureLogo: (data?.logoUrl ?? null) as string | null | undefined,
        ventureDescription: (data?.description ?? null) as string | null | undefined,
        ventureImage: (data?.heroUrl ?? null) as string | null | undefined,
        servicesHeading: servicesHeading as string | null | undefined,
        services: services.map((item) => ({
                    id: item.id,
                    name: item.name,
                    imageUrl: item.imageUrl,
                    link: item.link,
        })) as {
            id: string;
            name: string;
            imageUrl: string | null;
            link?: string | null;
        }[] | undefined,
        websiteUrl: (data?.websiteUrl ?? null) as string | null | undefined,
        contactEmail: (data?.contactEmail ?? null) as string | null | undefined,
        isLoading: isLoading as boolean | undefined,
    };

    if (Platform.OS === 'web') {
        return <VentureScreenWeb {...commonProps} />;
    }

    return <VentureScreen {...commonProps} />;
}

